<template>
  <div class="tdesign-starter-footer">
    <div v-if="!hideSystemName" class="text-center mb-8">{{ $t('腾讯IEG服务采购部供应商小课堂') }}</div>
    <div class="flex justify-center statement-box">
      <t-link hover="color" @click="changeSecurityDialog(true)">{{ $t('信息安全声明') }}</t-link>
      <t-link hover="color" @click="changePrivacyDialog(true)">{{ $t('隐私声明') }}</t-link>
      <span>Copyright © {{ startYear }} Tencent. All Rights Reserved</span>
    </div>

    <security-dialog v-model="securityVisible" @done="changeSecurityDialog(false)" />
    <privacy-dialog v-model="privacyVisible" @done="changePrivacyDialog(false)" />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

import SecurityDialog from '@/components/read-agree/securityDialog.vue';
import PrivacyDialog from '@/components/read-agree/privacyDialog.vue';

defineProps<{
  hideSystemName?: boolean;
}>();

const startYear = 2025;

// 信息安全
const securityVisible = ref(false);
const changeSecurityDialog = (status: boolean) => {
  securityVisible.value = status;
};

// 隐私声明
const privacyVisible = ref(false);
const changePrivacyDialog = (status: boolean) => {
  privacyVisible.value = status;
};
</script>

<style lang="less" scoped>
.tdesign-starter-footer {
  padding: 0 var(--td-comp-paddingLR-xl);
  color: var(--td-text-color-placeholder);
  font-size: 14px;
  line-height: 22px;

  .t-link {
    color: var(--td-text-color-placeholder);

    &:hover {
      color: var(--td-brand-color);
    }
  }
  .statement-box {
    margin: -8px;
    > * {
      margin: 8px;
    }
  }
}
</style>
